import Qe, { useSyncExternalStore as er, useRef as Gr, useEffect as me, useCallback as G } from "react";
import { Box as z, CircularProgress as Hr } from "@mui/material";
import { v4 as Kr } from "uuid";
import { debounce as Ve, clone as qe } from "lodash";
import { format as j, subDays as ge, isBefore as Xr, isEqual as Zr, isAfter as Qr, addDays as ne } from "date-fns";
import { TZDate as A } from "@date-fns/tz";
let D = { uuids: {} }, J = [];
const x = {
  blockingStarted: (r) => {
    D.uuids[r] = !0, D = { ...D }, ze();
  },
  blockingStopped: (r) => {
    delete D.uuids[r], D = { ...D }, ze();
  },
  subscribe(r) {
    return J = [...J, r], () => {
      J = J.filter((t) => t !== r);
    };
  },
  getSnapshot() {
    return D;
  }
};
function ze() {
  for (let r of J)
    r();
}
function rr() {
  const r = er(x.subscribe, x.getSnapshot);
  return Object.keys(r.uuids).length > 0;
}
var ve = { exports: {} }, V = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Je;
function et() {
  if (Je) return V;
  Je = 1;
  var r = Qe, t = Symbol.for("react.element"), i = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, v = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(p, c, R) {
    var E, O = {}, F = null, X = null;
    R !== void 0 && (F = "" + R), c.key !== void 0 && (F = "" + c.key), c.ref !== void 0 && (X = c.ref);
    for (E in c) s.call(c, E) && !v.hasOwnProperty(E) && (O[E] = c[E]);
    if (p && p.defaultProps) for (E in c = p.defaultProps, c) O[E] === void 0 && (O[E] = c[E]);
    return { $$typeof: t, type: p, key: F, ref: X, props: O, _owner: u.current };
  }
  return V.Fragment = i, V.jsx = a, V.jsxs = a, V;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ge;
function rt() {
  return Ge || (Ge = 1, process.env.NODE_ENV !== "production" && function() {
    var r = Qe, t = Symbol.for("react.element"), i = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), p = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), X = Symbol.for("react.offscreen"), ye = Symbol.iterator, fr = "@@iterator";
    function dr(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = ye && e[ye] || e[fr];
      return typeof n == "function" ? n : null;
    }
    var $ = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(e) {
      {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), l = 1; l < n; l++)
          o[l - 1] = arguments[l];
        pr("error", e, o);
      }
    }
    function pr(e, n, o) {
      {
        var l = $.ReactDebugCurrentFrame, m = l.getStackAddendum();
        m !== "" && (n += "%s", o = o.concat([m]));
        var g = o.map(function(d) {
          return String(d);
        });
        g.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, g);
      }
    }
    var mr = !1, vr = !1, gr = !1, hr = !1, yr = !1, be;
    be = Symbol.for("react.module.reference");
    function br(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === s || e === v || yr || e === u || e === R || e === E || hr || e === X || mr || vr || gr || typeof e == "object" && e !== null && (e.$$typeof === F || e.$$typeof === O || e.$$typeof === a || e.$$typeof === p || e.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === be || e.getModuleId !== void 0));
    }
    function Er(e, n, o) {
      var l = e.displayName;
      if (l)
        return l;
      var m = n.displayName || n.name || "";
      return m !== "" ? o + "(" + m + ")" : o;
    }
    function Ee(e) {
      return e.displayName || "Context";
    }
    function k(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case s:
          return "Fragment";
        case i:
          return "Portal";
        case v:
          return "Profiler";
        case u:
          return "StrictMode";
        case R:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            var n = e;
            return Ee(n) + ".Consumer";
          case a:
            var o = e;
            return Ee(o._context) + ".Provider";
          case c:
            return Er(e, e.render, "ForwardRef");
          case O:
            var l = e.displayName || null;
            return l !== null ? l : k(e.type) || "Memo";
          case F: {
            var m = e, g = m._payload, d = m._init;
            try {
              return k(d(g));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, B = 0, Te, Se, we, Re, _e, Oe, xe;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function Tr() {
      {
        if (B === 0) {
          Te = console.log, Se = console.info, we = console.warn, Re = console.error, _e = console.group, Oe = console.groupCollapsed, xe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        B++;
      }
    }
    function Sr() {
      {
        if (B--, B === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, e, {
              value: Te
            }),
            info: N({}, e, {
              value: Se
            }),
            warn: N({}, e, {
              value: we
            }),
            error: N({}, e, {
              value: Re
            }),
            group: N({}, e, {
              value: _e
            }),
            groupCollapsed: N({}, e, {
              value: Oe
            }),
            groupEnd: N({}, e, {
              value: xe
            })
          });
        }
        B < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = $.ReactCurrentDispatcher, se;
    function Z(e, n, o) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (m) {
            var l = m.stack.trim().match(/\n( *(at )?)/);
            se = l && l[1] || "";
          }
        return `
` + se + e;
      }
    }
    var ue = !1, Q;
    {
      var wr = typeof WeakMap == "function" ? WeakMap : Map;
      Q = new wr();
    }
    function ke(e, n) {
      if (!e || ue)
        return "";
      {
        var o = Q.get(e);
        if (o !== void 0)
          return o;
      }
      var l;
      ue = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var g;
      g = ie.current, ie.current = null, Tr();
      try {
        if (n) {
          var d = function() {
            throw Error();
          };
          if (Object.defineProperty(d.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(d, []);
            } catch (w) {
              l = w;
            }
            Reflect.construct(e, [], d);
          } else {
            try {
              d.call();
            } catch (w) {
              l = w;
            }
            e.call(d.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (w) {
            l = w;
          }
          e();
        }
      } catch (w) {
        if (w && l && typeof w.stack == "string") {
          for (var f = w.stack.split(`
`), S = l.stack.split(`
`), y = f.length - 1, b = S.length - 1; y >= 1 && b >= 0 && f[y] !== S[b]; )
            b--;
          for (; y >= 1 && b >= 0; y--, b--)
            if (f[y] !== S[b]) {
              if (y !== 1 || b !== 1)
                do
                  if (y--, b--, b < 0 || f[y] !== S[b]) {
                    var _ = `
` + f[y].replace(" at new ", " at ");
                    return e.displayName && _.includes("<anonymous>") && (_ = _.replace("<anonymous>", e.displayName)), typeof e == "function" && Q.set(e, _), _;
                  }
                while (y >= 1 && b >= 0);
              break;
            }
        }
      } finally {
        ue = !1, ie.current = g, Sr(), Error.prepareStackTrace = m;
      }
      var Y = e ? e.displayName || e.name : "", M = Y ? Z(Y) : "";
      return typeof e == "function" && Q.set(e, M), M;
    }
    function Rr(e, n, o) {
      return ke(e, !1);
    }
    function _r(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function ee(e, n, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ke(e, _r(e));
      if (typeof e == "string")
        return Z(e);
      switch (e) {
        case R:
          return Z("Suspense");
        case E:
          return Z("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case c:
            return Rr(e.render);
          case O:
            return ee(e.type, n, o);
          case F: {
            var l = e, m = l._payload, g = l._init;
            try {
              return ee(g(m), n, o);
            } catch {
            }
          }
        }
      return "";
    }
    var U = Object.prototype.hasOwnProperty, De = {}, Pe = $.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var n = e._owner, o = ee(e.type, e._source, n ? n.type : null);
        Pe.setExtraStackFrame(o);
      } else
        Pe.setExtraStackFrame(null);
    }
    function Or(e, n, o, l, m) {
      {
        var g = Function.call.bind(U);
        for (var d in e)
          if (g(e, d)) {
            var f = void 0;
            try {
              if (typeof e[d] != "function") {
                var S = Error((l || "React class") + ": " + o + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw S.name = "Invariant Violation", S;
              }
              f = e[d](n, d, l, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y) {
              f = y;
            }
            f && !(f instanceof Error) && (re(m), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", o, d, typeof f), re(null)), f instanceof Error && !(f.message in De) && (De[f.message] = !0, re(m), T("Failed %s type: %s", o, f.message), re(null));
          }
      }
    }
    var xr = Array.isArray;
    function ae(e) {
      return xr(e);
    }
    function Cr(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, o = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function kr(e) {
      try {
        return je(e), !1;
      } catch {
        return !0;
      }
    }
    function je(e) {
      return "" + e;
    }
    function Ae(e) {
      if (kr(e))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Cr(e)), je(e);
    }
    var Ie = $.ReactCurrentOwner, Dr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fe, Ne;
    function Pr(e) {
      if (U.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function jr(e) {
      if (U.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ar(e, n) {
      typeof e.ref == "string" && Ie.current;
    }
    function Ir(e, n) {
      {
        var o = function() {
          Fe || (Fe = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: o,
          configurable: !0
        });
      }
    }
    function Fr(e, n) {
      {
        var o = function() {
          Ne || (Ne = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: o,
          configurable: !0
        });
      }
    }
    var Nr = function(e, n, o, l, m, g, d) {
      var f = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: o,
        props: d,
        // Record the component responsible for creating this element.
        _owner: g
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function Mr(e, n, o, l, m) {
      {
        var g, d = {}, f = null, S = null;
        o !== void 0 && (Ae(o), f = "" + o), jr(n) && (Ae(n.key), f = "" + n.key), Pr(n) && (S = n.ref, Ar(n, m));
        for (g in n)
          U.call(n, g) && !Dr.hasOwnProperty(g) && (d[g] = n[g]);
        if (e && e.defaultProps) {
          var y = e.defaultProps;
          for (g in y)
            d[g] === void 0 && (d[g] = y[g]);
        }
        if (f || S) {
          var b = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          f && Ir(d, b), S && Fr(d, b);
        }
        return Nr(e, f, S, m, l, Ie.current, d);
      }
    }
    var le = $.ReactCurrentOwner, Me = $.ReactDebugCurrentFrame;
    function L(e) {
      if (e) {
        var n = e._owner, o = ee(e.type, e._source, n ? n.type : null);
        Me.setExtraStackFrame(o);
      } else
        Me.setExtraStackFrame(null);
    }
    var ce;
    ce = !1;
    function fe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function We() {
      {
        if (le.current) {
          var e = k(le.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Wr(e) {
      return "";
    }
    var $e = {};
    function $r(e) {
      {
        var n = We();
        if (!n) {
          var o = typeof e == "string" ? e : e.displayName || e.name;
          o && (n = `

Check the top-level render call using <` + o + ">.");
        }
        return n;
      }
    }
    function Le(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var o = $r(n);
        if ($e[o])
          return;
        $e[o] = !0;
        var l = "";
        e && e._owner && e._owner !== le.current && (l = " It was passed a child from " + k(e._owner.type) + "."), L(e), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', o, l), L(null);
      }
    }
    function Ye(e, n) {
      {
        if (typeof e != "object")
          return;
        if (ae(e))
          for (var o = 0; o < e.length; o++) {
            var l = e[o];
            fe(l) && Le(l, n);
          }
        else if (fe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var m = dr(e);
          if (typeof m == "function" && m !== e.entries)
            for (var g = m.call(e), d; !(d = g.next()).done; )
              fe(d.value) && Le(d.value, n);
        }
      }
    }
    function Lr(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var o;
        if (typeof n == "function")
          o = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === O))
          o = n.propTypes;
        else
          return;
        if (o) {
          var l = k(n);
          Or(o, e.props, "prop", l, e);
        } else if (n.PropTypes !== void 0 && !ce) {
          ce = !0;
          var m = k(n);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Yr(e) {
      {
        for (var n = Object.keys(e.props), o = 0; o < n.length; o++) {
          var l = n[o];
          if (l !== "children" && l !== "key") {
            L(e), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), L(null);
            break;
          }
        }
        e.ref !== null && (L(e), T("Invalid attribute `ref` supplied to `React.Fragment`."), L(null));
      }
    }
    var Be = {};
    function Ue(e, n, o, l, m, g) {
      {
        var d = br(e);
        if (!d) {
          var f = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S = Wr();
          S ? f += S : f += We();
          var y;
          e === null ? y = "null" : ae(e) ? y = "array" : e !== void 0 && e.$$typeof === t ? (y = "<" + (k(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : y = typeof e, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y, f);
        }
        var b = Mr(e, n, o, m, g);
        if (b == null)
          return b;
        if (d) {
          var _ = n.children;
          if (_ !== void 0)
            if (l)
              if (ae(_)) {
                for (var Y = 0; Y < _.length; Y++)
                  Ye(_[Y], e);
                Object.freeze && Object.freeze(_);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ye(_, e);
        }
        if (U.call(n, "key")) {
          var M = k(e), w = Object.keys(n).filter(function(Jr) {
            return Jr !== "key";
          }), de = w.length > 0 ? "{key: someKey, " + w.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Be[M + de]) {
            var zr = w.length > 0 ? "{" + w.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, de, M, zr, M), Be[M + de] = !0;
          }
        }
        return e === s ? Yr(b) : Lr(b), b;
      }
    }
    function Br(e, n, o) {
      return Ue(e, n, o, !0);
    }
    function Ur(e, n, o) {
      return Ue(e, n, o, !1);
    }
    var Vr = Ur, qr = Br;
    q.Fragment = s, q.jsx = Vr, q.jsxs = qr;
  }()), q;
}
process.env.NODE_ENV === "production" ? ve.exports = et() : ve.exports = rt();
var P = ve.exports;
function tt() {
  return rr() ? P.jsx(z, { sx: {
    display: "flex",
    backgroundColor: "rgba(0,0,0,0.4)",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
    position: "fixed",
    height: "100vh",
    width: "100vw",
    zIndex: 15e3,
    left: 0,
    top: 0
  }, children: P.jsx(Hr, { color: "primary", thickness: 6, size: 50 }) }) : null;
}
function nt() {
  const r = D.uuids;
  return Object.keys(r).length > 0;
}
function ot(r) {
  x.blockingStarted(r);
}
function it(r) {
  x.blockingStopped(r);
}
function tr(r) {
  const t = Gr(""), s = er(x.subscribe, x.getSnapshot).uuids[t.current];
  return me(() => (t.current = Kr(), () => {
    x.blockingStopped(t.current);
  }), []), me(() => {
    !s && r ? x.blockingStarted(t.current) : s && r === !1 && x.blockingStopped(t.current);
  }, [r, s]), {
    blockingStarted: G(() => {
      x.blockingStarted(t.current);
    }, []),
    blockingStopped: G(() => {
      x.blockingStopped(t.current);
    }, [])
  };
}
function st(r) {
  const { blockingStarted: t, blockingStopped: i } = tr();
  return async (...s) => {
    t();
    const u = await r(...s);
    return i(), u;
  };
}
const nr = {
  zIndex: 100,
  position: "sticky",
  pointerEvents: "none"
}, He = {
  ...nr,
  left: 0,
  minWidth: "100%",
  height: "40px",
  minHeight: "40px",
  marginTop: "-40px"
}, Ke = {
  ...nr,
  top: 0,
  minHeight: "100%",
  width: "20px",
  minWidth: "20px",
  marginLeft: "-20px"
}, ut = {
  top: 0,
  backgroundImage: "radial-gradient(farthest-side at 50% 0%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)",
  opacity: 0
}, at = {
  bottom: 0,
  backgroundImage: "radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)"
}, lt = {
  left: 0,
  backgroundImage: "radial-gradient(farthest-side at 0% 50%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)",
  opacity: 0
}, ct = {
  right: 0,
  backgroundImage: "radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)"
};
function Lt({ children: r, containerRef: t, direction: i = "column", styleTopShadow: s = {}, styleBottomShadow: u = {}, threshold: v = 40 }) {
  return ft({ direction: i, container: t, threshold: v }), P.jsxs(P.Fragment, { children: [i == "column" ? P.jsx(z, { className: "shadow--top", sx: { ...He, ...ut, ...s } }) : null, i == "row" ? P.jsx(z, { className: "shadow--left", sx: { ...Ke, ...lt, ...s } }) : null, r, i == "column" ? P.jsx(z, { className: "shadow--bottom", sx: { ...He, ...at, ...u } }) : null, i == "row" ? P.jsx(z, { className: "shadow--right", sx: { ...Ke, ...ct, ...u } }) : null] });
}
const te = 150, pe = te;
function ft({ container: r, direction: t, threshold: i }) {
  const s = G(Ve(() => {
    if (r.current) {
      if (t == "column") {
        const a = r.current.querySelector(".shadow--top"), p = r.current.querySelector(".shadow--bottom");
        if (a && p) {
          const c = r.current.scrollHeight - r.current.offsetHeight;
          c < i ? (a.style.opacity = String(0), p.style.opacity = String(0)) : (a.style.opacity = String(Math.min(r.current.scrollTop / te, 1)), p.style.opacity = String(Math.min((c - r.current.scrollTop) / te, 1)));
        }
      } else if (t == "row") {
        const a = r.current.querySelector(".shadow--left"), p = r.current.querySelector(".shadow--right");
        if (a && p) {
          const c = r.current.scrollWidth - r.current.offsetWidth;
          c < i ? (a.style.opacity = String(0), p.style.opacity = String(0)) : (a.style.opacity = String(Math.min(r.current.scrollLeft / pe, 1)), p.style.opacity = String(Math.min((c - r.current.scrollLeft) / pe, 1)));
        }
      }
    }
  }), [r.current]), u = G((a) => {
    if (a) {
      if (t == "column") {
        const p = a.scrollHeight - a.offsetHeight, c = a.querySelector(".shadow--bottom");
        c && (p < i ? c.style.opacity = "0" : c.style.opacity = String(Math.min((p - a.scrollTop) / te, 1)));
      } else if (t == "row") {
        const p = a.scrollWidth - a.offsetWidth, c = a.querySelector(".shadow--right");
        c && (p < i ? c.style.opacity = "0" : c.style.opacity = String(Math.min((p - a.scrollLeft) / pe, 1)));
      }
    }
  }, []), v = G(Ve(() => {
    const a = r.current;
    a && u(a);
  }), [r.current]);
  return me(() => {
    const a = r.current;
    let p = null;
    return a && (u(a), a.addEventListener("scroll", s), a.addEventListener("resize", v), p = new MutationObserver(v), p.observe(a, { subtree: !0, childList: !0 })), () => {
      a == null || a.removeEventListener("resize", v), a == null || a.removeEventListener("scroll", s), p == null || p.disconnect();
    };
  }, [r, v, s]), r;
}
function K(r) {
  return dt(typeof r == "string" ? r : r.hours);
}
function dt(r) {
  const t = r.split("-");
  return { start: Xe(t[0]), end: Xe(t[1]) };
}
function Xe(r) {
  const t = r.split(":");
  return { hours: Number(t[0]), minutes: Number(t[1]) };
}
function or(r, t) {
  return r.hours == t.hours && r.minutes == t.minutes;
}
function ir(r, t) {
  return H(r) > H(t);
}
function pt(r, t) {
  return H(r) < H(t);
}
function mt(r, t) {
  return or(r, t) || ir(r, t);
}
function H(r) {
  return r.hours * 60 + r.minutes;
}
function vt(r) {
  return String(r.hours).padStart(2, "0") + ":" + String(r.minutes).padStart(2, "0");
}
function gt(r) {
  return {
    hours: Number(j(r, "H")),
    minutes: Number(j(r, "m"))
  };
}
const h = { isSame: or, isBefore: pt, isAfter: ir, isSameOrAfter: mt, timeToNumber: H, fromDate: gt, timeToString: vt };
function ht(r) {
  return h.isAfter(r.start, r.end);
}
function sr(r) {
  return ht(r);
}
function ur(r, t) {
  return h.isSameOrAfter(t, r.start) && (sr(r) || h.isBefore(t, r.end));
}
function yt(r, t) {
  return sr(r) && ur({ ...r, start: { hours: 0, minutes: 0 } }, t);
}
function bt(r) {
  return `${h.timeToString(r.start)}-${h.timeToString(r.end)}`;
}
function Et(r, t) {
  return h.isSame(r.start, t.start) && h.isSame(r.end, t.end);
}
const he = { containsTime: ur, containsNightTime: yt, timeRangeToString: bt, timeRangesAreEqual: Et };
function ar(r, t) {
  return h.isBefore(r, t.start) ? t : null;
}
function Tt(r, t) {
  var i;
  return ((i = ar(r, t)) == null ? void 0 : i.start) ?? null;
}
function St(r, t) {
  var i;
  return ((i = ar(r, t)) == null ? void 0 : i.end) ?? null;
}
function wt(r, t) {
  return he.containsTime(t, r) ? t.end : null;
}
function Rt(r, t) {
  for (const i of r)
    if (he.containsNightTime(K(i), t))
      return !0;
  return !1;
}
function lr(r, t) {
  for (const i of r)
    if (he.containsTime(K(i), t))
      return !0;
  return !1;
}
function _t(r) {
  return lr(r, { hours: 23, minutes: 59 });
}
function Ot(r, t) {
  for (const i of r.map((s) => K(s)).sort((s, u) => h.timeToNumber(s.start) - h.timeToNumber(u.start))) {
    const s = Tt(h.fromDate(t), i);
    if (s)
      return s;
  }
  return null;
}
function xt(r, t) {
  const i = r.map((s) => K(s)).sort((s, u) => h.timeToNumber(s.end) - h.timeToNumber(u.end));
  for (const s of i) {
    const u = wt(h.fromDate(t), s);
    if (u)
      return u;
  }
  for (const s of i) {
    const u = St(h.fromDate(t), s);
    if (u)
      return u;
  }
  return null;
}
const C = {
  isOpenAtNight: Rt,
  nextClose: xt,
  nextOpen: Ot,
  isOpenAtTheEndOfTheDay: _t,
  isOpenAt: lr
}, Ct = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"], Yt = (r) => Ct.includes(r);
function Bt(r, t) {
  return (r == null ? void 0 : r.some((i) => cr(t, typeof i == "string" ? i : i.hours))) ?? !1;
}
function cr(r, t) {
  const [i, s] = t.split("-"), [u, v] = i.split(":"), [a, p] = s.split(":");
  let c = qe(r);
  c.setHours(Number(u), Number(v), 0, 0);
  let R = qe(r);
  R.setHours(Number(a), Number(p), 0, 0);
  const E = 60 * Number(a) + Number(p), O = 60 * Number(u) + Number(v);
  return E < O && (c = ge(c, 1)), (Xr(c, r) || Zr(c, r)) && Qr(R, r);
}
function W(r, t) {
  var i, s;
  return ((i = r.exceptions) == null ? void 0 : i[j(t, "yyyy-MM-dd")]) ?? ((s = r.exceptions) == null ? void 0 : s[j(t, "MM-dd")]) ?? r[j(t, "EEEE").toLowerCase()] ?? [];
}
function kt(r, t) {
  var s, u, v;
  return ((v = [...((s = r.exceptions) == null ? void 0 : s[j(t, "yyyy-MM-dd")]) ?? ((u = r.exceptions) == null ? void 0 : u[j(t, "MM-dd")]) ?? r[j(t, "EEEE").toLowerCase()] ?? null ?? []].reverse()) == null ? void 0 : v.find((a) => cr(t, typeof a == "string" ? a : a.hours))) ?? null;
}
function I(r) {
  return r.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function Dt(r, t) {
  const i = kt(r, t);
  return i ? K(i) : null;
}
function Pt(r, t = null, i = null) {
  t = t ?? new A(/* @__PURE__ */ new Date(), I(r)), t = new A(t.getTime(), I(r));
  let s = W(r, t), u = C.nextOpen(s, t), v = 366;
  for (; !u || u.hours >= 24; ) {
    if (--v < 0)
      return null;
    if (t = ne(t, 1), t == null || t.setHours(0, 0, 0, 0), oe(r, t) && !C.isOpenAtTheEndOfTheDay(s))
      return t;
    if (i && (t == null ? void 0 : t.getTime()) > i.getTime())
      return i;
    s = W(r, t), u = C.nextOpen(s, t);
  }
  return u ? (t == null || t.setHours(u.hours, u.minutes, 0, 0), t) : null;
}
function jt(r, t = null, i = null) {
  var p;
  t = t ?? new A(/* @__PURE__ */ new Date(), I(r)), t = new A(t.getTime(), I(r));
  const s = (p = Dt(r, t)) == null ? void 0 : p.end;
  if (s && s.hours < 24)
    return t.setHours(s.hours, s.minutes, 0, 0), t;
  let u = null;
  {
    const c = ge(t, 1), R = W(r, c);
    C.isOpenAtNight(R, h.fromDate(c)) && (u = C.nextClose(R, t));
  }
  let v = W(r, t);
  u || (u = C.nextClose(v, t), u && u.hours < 24 && (h.timeToNumber(u) < h.timeToNumber(h.fromDate(t)) || Ze(r, t) && h.timeToNumber(h.fromDate(Pt(r, t) ?? /* @__PURE__ */ new Date("2100-00-00 00:00:00"))) > h.timeToNumber(u)) && (t = ne(t, 1)));
  let a = 366;
  for (; !u || u.hours >= 24; ) {
    if (--a < 0)
      return null;
    if (t = ne(t, 1), t == null || t.setHours(0, 0, 0, 0), Ze(r, t) && C.isOpenAtTheEndOfTheDay(v))
      return t;
    if (i && (t == null ? void 0 : t.getTime()) > i.getTime())
      return i;
    v = W(r, t), u = C.nextClose(v, t);
  }
  return u ? (t == null || t.setHours(u.hours, u.minutes, 0, 0), t) : null;
}
function At(r) {
  return oe(r, /* @__PURE__ */ new Date());
}
function Ut(r) {
  return !At(r);
}
function Ze(r, t) {
  return !oe(r, t);
}
function oe(r, t) {
  t = t ?? new A(/* @__PURE__ */ new Date(), I(r)), t = new A(t.getTime(), I(r));
  {
    const s = ge(t, 1), u = W(r, s);
    if (C.isOpenAtNight(u, h.fromDate(s)))
      return !0;
  }
  const i = W(r, t);
  return C.isOpenAt(i, h.fromDate(t));
}
function Vt(r, t, i = 7) {
  t = t ?? new A(/* @__PURE__ */ new Date(), I(r)), t = new A(t.getTime(), I(r)), t.setMilliseconds(30);
  const s = oe(r, t), u = ne(t, i), v = jt(r, t, u);
  return s && u.getTime() == (v == null ? void 0 : v.getTime());
}
const qt = {
  useIsUserInputBlocked: rr,
  isUserInputBlocked: nt,
  useBlockUserInput: tr,
  useWrapPromise: st,
  blockingStarted: ot,
  blockingStopped: it,
  View: tt
};
export {
  qt as BlockUserInput,
  Lt as ScrollShadows,
  h as TimeMethods,
  he as TimeRangeMethods,
  Dt as currentOpenRange,
  Ct as days,
  W as forDate,
  kt as forDateTime,
  K as getTimeRangeOfOpeningHoursForDay,
  I as getTimezone,
  Ut as isClosed,
  Ze as isClosedAt,
  Yt as isOfTypeDay,
  At as isOpen,
  oe as isOpenAt,
  Vt as isOpenComingDays,
  Bt as isOpenInOpeningHoursForDay,
  cr as isOpenInTimeRange,
  jt as nextClose,
  Pt as nextOpen
};
